<mat-spinner *ngIf="loading" [diameter]="60"></mat-spinner>
<mat-tab-group
  dynamicHeight
  fitInkBarToContent
  mat-stretch-tabs="false"
  mat-align-tabs="center"
  [preserveContent]="true"
  [animationDuration]="0"
>
  <mat-tab *ngFor="let c of categories; let i = index">
    <ng-template mat-tab-label>
      {{ c.name }}
    </ng-template>
    <ng-template matTabContent>
      <div
        class="card"
        *ngFor="let item of c.platforms"
        (click)="openPlatformModal(item)"
      >
        <app-image [fileid]="item.icon" [radius]="8"></app-image>
        <span>{{ item.name }}</span>
      </div>
    </ng-template>
  </mat-tab>
</mat-tab-group>
